import React, { ReactNode } from 'react';

interface FuturisticFeatureCardProps {
  title: string;
  description: string;
  icon?: ReactNode;
  color?: 'primary' | 'secondary' | 'accent' | 'neon-purple' | 'neon-pink' | 'neon-teal';
  hoverEffect?: boolean;
  animatedIcon?: boolean;
  className?: string;
}

const FuturisticFeatureCard: React.FC<FuturisticFeatureCardProps> = ({
  title,
  description,
  icon,
  color = 'primary',
  hoverEffect = true,
  animatedIcon = false,
  className = '',
}) => {
  const getIconColor = () => {
    switch (color) {
      case 'accent':
      case 'neon-purple':
        return 'text-neu-accent';
      case 'secondary':
      case 'neon-teal':
        return 'text-neu-teal';
      case 'neon-pink':
        return 'text-rose-500';
      default:
        return 'text-neu-accent';
    }
  };

  return (
    <div
      className={[
        'relative bg-neu-bg rounded-neu p-8',
        'shadow-[10px_10px_20px_rgb(163,177,198,0.7),-10px_-10px_20px_rgba(255,255,255,0.65)]',
        hoverEffect
          ? 'transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-[14px_14px_26px_rgb(163,177,198,0.75),-14px_-14px_26px_rgba(255,255,255,0.7)]'
          : '',
        className,
      ].join(' ')}
    >
      {icon && (
        <div
          className={[
            'flex items-center justify-center w-14 h-14 rounded-full mb-6',
            getIconColor(),
            // Deep inset well for the icon
            'shadow-[inset_8px_8px_16px_rgb(163,177,198,0.7),inset_-8px_-8px_16px_rgba(255,255,255,0.6)]',
            'bg-neu-bg',
          ].join(' ')}
        >
          {icon}
        </div>
      )}

      <h3 className={`text-xl font-display font-bold mb-3 ${getIconColor()}`}>{title}</h3>

      <p className="text-neu-muted leading-relaxed">{description}</p>
    </div>
  );
};

export default FuturisticFeatureCard;
